const apiUrl =
  import.meta.env.VITE_API_URL || (import.meta.env.PROD ? 'https://cdapp.api.evenfi.com' : '/')

// The websocket (centrifugo) is served by the API host, not by the frontend nginx.
// In development the Vite proxy forwards /connection to the API, so same-origin works;
// in production builds point straight at the API host (like criptalia-web does).
function resolveWebsocketUrl() {
  if (import.meta.env.VITE_WEBSOCKET_URL) {
    return import.meta.env.VITE_WEBSOCKET_URL.replace(/\/$/, '') + '/connection/websocket'
  }
  if (typeof window === 'undefined') return 'wss://cdapp.api.evenfi.com/connection/websocket'
  const sameOrigin =
    (window.location.protocol === 'https:' ? 'wss://' : 'ws://') +
    window.location.host +
    '/connection/websocket'
  if (!import.meta.env.PROD || !/^https?:\/\//.test(apiUrl)) return sameOrigin
  return apiUrl.replace(/^http/, 'ws').replace(/\/$/, '') + '/connection/websocket'
}
const websocketUrl = resolveWebsocketUrl()

export const FRONTEND_ENV = {
  isProduction: import.meta.env.PROD,
  isDevelopment: import.meta.env.DEV,
  websocketUrl,
  apiUrl,
  appName: 'ClubDeal Portal',
  appVersion: import.meta.env.VITE_VERSION || 'dev',
  datocmsToken: import.meta.env.VITE_DATO_CMS_TOKEN || '120e376c3c2da3c3d867ca8fc16aa4',
  // Read-only token of the cdapp DatoCMS project (datocms-assets.com/177673) where the
  // backend stores the campaign content (full description).
  datocmsCampaignsToken:
    import.meta.env.VITE_DATO_CMS_CAMPAIGNS_TOKEN || 'a3290d46886227e346035297d6206a',
  mapsApiKey: import.meta.env.VITE_MAPS_API_KEY || 'AIzaSyB15ds5CBvNKu8VGdxMxKp7nVPPLYtqQkM',
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6LdN4qUrAAAAAKzFC2TyvCQ7-pDB0ewKvfADrpVx',
}